import styled, { css } from 'styled-components';
import { Skeleton } from '@/UI';

export const CardLocalItemSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 255px;
  border: ${({ theme }) => `1px solid ${theme.palette.grays20}`};
  border-radius: ${({ theme }) => theme.borderRadius.md};
`;

export const StyledSkeletonImage = styled(Skeleton)`
  ${({ theme }) => css`
    min-height: 90px;
    height: 50%;
    width: 100%;
    border-radius: 8px 8px 0 0;
  `}
`;

export const DescriptionContainer = styled.div`
  padding: ${({ theme }) => theme.spacing[16]};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing[16]};
  padding-top: 0px;
`;
